(() => {
  if (window.chiraganShowroomMeasurementLoaded) return;
  window.chiraganShowroomMeasurementLoaded = true;
  const destination = 'G-LH3VX1SSL0';
  const storageKey = 'chiragan_showroom_submission_v1';
  const params = new URLSearchParams(location.search);
  const testMode = params.get('chiragan_tracking_test') === '1';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const removePending = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };
  const send = (name) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', testMode ? 'showroom_tracking_test' : name, {
      send_to: destination,
      showroom_action: name,
      showroom_location: 'coral_gables',
      page_location: location.origin + location.pathname,
      ...(testMode ? { debug_mode: true } : {})
    });
    if (testMode) {
      const status = document.getElementById('ChiraganMeasurementTest');
      if (status) status.textContent = 'Test event queued: ' + name;
    }
    return true;
  };
  document.querySelectorAll('a[href]').forEach(link => {
    const href = new URL(link.href, location.origin);
    if (href.origin === location.origin && href.pathname.endsWith('/pages/contact-us') && /showroom appointment/i.test(link.textContent)) {
      href.searchParams.set('enquiry', 'showroom');
      href.hash = 'contact_form';
      link.href = href.href;
    }
  });
  const form = document.querySelector('.page-contact-form');
  const topic = document.getElementById('ContactFormTopic');
  if (topic && params.get('enquiry') === 'showroom') topic.value = 'Showroom visit';
  if (form && topic) {
    form.addEventListener('submit', event => {
      removePending();
      if (event.defaultPrevented || !form.checkValidity() || topic.value !== 'Showroom visit' || !allowed()) return;
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ submittedAt: Date.now(), path: location.pathname, testMode }));
      } catch (_) {}
    });
  }
  function confirmEnquiry() {
    if (document.querySelector('[data-chiragan-contact-error]')) { removePending(); return; }
    if (!document.querySelector('[data-chiragan-contact-success]') || !allowed()) return;
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(storageKey)); } catch (_) { return; }
    if (!pending) return;
    if (pending.path !== location.pathname || pending.testMode !== testMode || Date.now() - pending.submittedAt > 1800000 || Date.now() < pending.submittedAt) { removePending(); return; }
    if (send('showroom_enquiry')) removePending();
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href^="tel:"]');
    if (!link || link.getAttribute('href').replace(/[^\d]/g, '') !== '17862471786') return;
    if (testMode) event.preventDefault();
    send('showroom_phone_click');
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) removePending();
    confirmEnquiry();
  });
  if (testMode) {
    const status = document.createElement('p');
    status.id = 'ChiraganMeasurementTest';
    status.setAttribute('role', 'status');
    status.textContent = 'Measurement test mode: phone links send a test event without opening the dialler.';
    document.body.append(status);
  }
  if (window.Shopify?.customerPrivacy) confirmEnquiry();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) confirmEnquiry(); });
})();